module.exports = __webpack_public_path__ + "media/images/index/line-6b6862d66e1d3d48f2a3e2e01e683f0a.svg";